import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function HowItWorksPage() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8 bg-gradient-to-b from-pink-100 to-white">
      <div className="w-full max-w-3xl flex flex-col items-center bg-white/90 rounded-2xl shadow-lg p-8 md:p-12">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6 text-center">
          {t('howItWorks.title')}
        </h1>
        <p className="text-xl text-gray-600 mb-10 text-center">
          {t('howItWorks.description')}
        </p>
        <ol className="space-y-8 w-full">
          <li className="flex items-start gap-4">
            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-pink-500 text-white rounded-full text-2xl font-bold">1</span>
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-1">{t('howItWorks.step1Title')}</h2>
              <p className="text-gray-600">{t('howItWorks.step1Description')}</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-pink-500 text-white rounded-full text-2xl font-bold">2</span>
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-1">{t('howItWorks.step2Title')}</h2>
              <p className="text-gray-600">{t('howItWorks.step2Description')}</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-pink-500 text-white rounded-full text-2xl font-bold">3</span>
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-1">{t('howItWorks.step3Title')}</h2>
              <p className="text-gray-600">{t('howItWorks.step3Description')}</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-pink-500 text-white rounded-full text-2xl font-bold">4</span>
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-1">{t('howItWorks.step4Title')}</h2>
              <p className="text-gray-600">{t('howItWorks.step4Description')}</p>
            </div>
          </li>
        </ol>
        <div className="mt-10 mb-4 flex flex-col sm:flex-row gap-4 w-full max-w-md">
          <a
            href="https://wa.me/905372243441"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-3 px-6 py-4 bg-green-500 hover:bg-green-600 text-white text-lg font-semibold rounded-xl transition shadow-md"
          >
            <FaWhatsapp size={32} />
            {t('howItWorks.whatsappButton')}
          </a>
          <a
            href="https://instagram.com/weddingram.me"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white text-lg font-semibold rounded-xl transition shadow-md"
          >
            <FaInstagram size={32} />
            {t('howItWorks.instagramButton')}
          </a>
        </div>
        <Link
          to="/"
          className="px-6 py-3 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-xl transition shadow-md"
        >
          {t('howItWorks.homeButton')}
        </Link>
      </div>
    </div>
  );
}

export default HowItWorksPage; 